const headerDataUni = [
    {
      prop: "InvAddCode",
      label: "产品代码",
      columnwidth: 117,
    },
    {
      prop: "InvName",
      label: "产品名称",
      columnwidth: 133,
    },
    {
      prop: "Batch",
      label: "批号",
      columnwidth: 110,
    },
    {
      prop: "Quantity",
      label: "上架数量",
      columnwidth: 82,
    },
    {
      prop: "InvUniqueCode",
      label: "唯一码",
      columnwidth: 150,
    },
  ];
  export default headerDataUni;
  